import { Component, OnInit, Inject, OnDestroy, ViewChild } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {AuthService, ApiService, PdfdataService} from 'src/app/services/service.index';
import { ActivatedRoute, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { WINDOW } from 'src/app/services/window.service';
import { AppLockSessionComponent } from 'src/app/shared/app-lock-session/app-lock-session.component';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { loaderConfig } from '../../config/loader';
import { environment } from '../../../environments/environment';
import {DateUtilsService} from '../../services/date-utils.service';

/**
 * FineGroupComponent
 *
 * @author Jesús Fernández
 *
 * Show fines group
 */
@Component({
    selector: 'app-groupfine',
    templateUrl: './finegroup.component.html',
    styleUrls: ['./finegroup.component.css']
})
export class FinegroupComponent implements OnInit, OnDestroy {
    public loaderOptions: any = loaderConfig;
    public dataLoaded = false;
    public noFinesSelected = true;
    public selectedItemsList = [];
    public dtOptions: DataTables.Settings = {};
    public fines = [];
    public checkAll = false;
    private hash: string;
    private param_hash: string;
    private checksesInterval: any;
    private subscription: Subscription = new Subscription();
    public checkedIDs = [];
    public showModal = false;
    public rolAcceso;
    public diffHrs: number;
    public diffMins: number;
    public submitDiv: any;
    public showMultibancoInfo = false;
    @ViewChild('lockSession') private lockSession: AppLockSessionComponent;
    public showCancelButton = false;
    public showPaymentCancelationModal = false;
    public finesToCancel: any;
    public loadingFinesToCancel = false;
    public loadingCancelation = false;
    public showCancelationMessage = false;
    public finesToCancelTable = [];
    public multibancoValues: any[] = [];
    public regularValues: any[] = [];
    public cancelationMessage = '';
    public errorCanceling = false;
    public viewFineModal = false;
    public actualFine: any;
    public isprontopagofine = true;
    public hasDiscount = false;
    public pagoActivo = false;
    public filePdfUrl: any;
    public filePdfUrlPagado: any;
    public justificantePagoOrganismo: any;

    /**
     * @ignore
     */
    constructor(private http: HttpClient,
                private router: Router,
                private route: ActivatedRoute,
                private apiService: ApiService,
                private authService: AuthService,
                private translate: TranslateService,
                private ngxLoader: NgxUiLoaderService,
                private pdfdataService: PdfdataService,
                @Inject(DOCUMENT) private _document,
                @Inject(WINDOW) private window: Window) {
        this.hash = this.authService.getHash();
        this.route.params.subscribe(params => {
            this.param_hash = params['hash'];
        });
    }

    ngOnInit() {
        localStorage.removeItem('expedientes');
        localStorage.removeItem('summary');
        this.ngxLoader.start();
        if (this.hash !== this.param_hash) {
            this.lockSession.open();
            return false;
        }
        this.checksesInterval = setInterval(() => {
            this.hash = this.authService.getHash();
            if (this.hash !== this.param_hash) {
                this.lockSession.open();
                clearInterval(this.checksesInterval);
                return false;
            }
        }, 1000 * 60);
        this.getFines();
    }

    ngOnDestroy() {
        clearInterval(this.checksesInterval);
        this.subscription.unsubscribe();
    }

    getFines() {
        this.apiService.getFineData(`${this.hash}`, `${this.checkedIDs[0]}`)
            .subscribe((response: any) => {
                    this.drawTable(response);
                    this.ngxLoader.stop();
                },
                error => {
                    this.authService.logout();
                    this.router.navigate([`/app/login/pyf/${this.hash}`], {queryParams: {error: error.status}});
                    this.ngxLoader.stop();
                });
    }

    checkMultibancoCancelledSources() {
        this.finesToCancel = [];
        this.showModal = false;
        this.showPaymentCancelationModal = true;
        this.loadingFinesToCancel = true;
        const URL_API = environment.URL_API;
        const url = URL_API + 'comprobar-cancelacion/' + this.authService.getHash();
        const params = {
            'idEnlaces': this.multibancoValues
        };
        const headers: HttpHeaders = new HttpHeaders().set('TOKEN', this.authService.getToken());
        return this.http.post<any>(url, params, {headers}).subscribe(
            data => {
                this.loadingFinesToCancel = false;
                this.finesToCancel = data;
                this.drawFinesToCancel();
            },
            error => {
                this.loadingFinesToCancel = false;
            }
        );
    }

    drawFinesToCancel() {
        this.finesToCancelTable = [];
        for (let i = 0; i < this.fines.length; i++) {
            for (let j = 0; j < this.finesToCancel.length; j++) {
                if (this.fines[i].referencia === this.finesToCancel[j]) {
                    const tr = {
                        referencia: this.fines[i].referencia,
                        nombre: this.fines[i].cliente,
                        matricula: this.fines[i].matricula,
                        organismo: this.fines[i].nombreOrganismo,
                        lugar: this.fines[i].lugar,
                        importeBrutoSinDescuento: this.fines[i].importeBrutoSinDescuento
                    };
                    this.finesToCancelTable.push(tr);
                }
            }
        }
    }

    cancelMultibanco() {
        const idsEnlace = this.fines.filter(fine => this.finesToCancel.includes(fine.referencia)).map(fine => fine.idEnlace);
        this.errorCanceling = false;
        this.loadingCancelation = true;
        const params = {
            'idEnlaces': idsEnlace
        };
        const URL_API = environment.URL_API;
        const url = URL_API + 'cancelar-pago/' + this.authService.getHash();
        const headers: HttpHeaders = new HttpHeaders().set('TOKEN', this.authService.getToken());
        return this.http.post<any>(url, params, {headers}).subscribe(
            data => {
                this.errorCanceling = false;
                this.loadingCancelation = false;
                this.showCancelationMessage = true;
                this.cancelationMessage = this.translate.instant('PopUps.Cancelation.CancelationMessage.Success');
            },
            error => {
                this.errorCanceling = true;
                this.loadingCancelation = false;
                this.showCancelationMessage = true;
                this.cancelationMessage = this.translate.instant('PopUps.Cancelation.CancelationMessage.Error');
            }
        );
    }

    drawTable(data) {
        for (let i = 0; i < data.length; i++) {
            if (data[i].pagoActivo) {
                this.pagoActivo = true;
            }
            let importe = data[i].importeBrutoSinDescuento;
            if (importe === undefined) {
                importe = 0;
            }
            const fechaHoraServidor = data[i].fechaHoraServidor.date;
            const fechaFinEnlace = data[i].fechaFinEnlace.date;
            const dateExpires = new Date(fechaFinEnlace.replace(' ', 'T'));
            const nowdate = new Date(fechaHoraServidor.replace(' ', 'T'));
            let timeOut = false;
            let diffMs;
            let diffDays;
            let diffHrs;
            let diffMins;
            const estados = {
                '1': 'enviado',
                '2': 'pagado',
                '3': 'identificado',
                '4': 'compartido',
                '5': 'vencido',
                '6': 'rechazado',
                '7': 'multibanco'
            };
            let estado = estados[data[i].acceso];
            let statusLabel = '';
            if (nowdate.getTime() > dateExpires.getTime()) {
                timeOut = true;
            } else {
                diffMs = Math.abs(dateExpires.getTime() - nowdate.getTime() );
                diffDays = Math.floor(diffMs / 86400000);
                diffHrs = Math.floor((diffMs % 86400000) / 3600000);
                diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);
            }
            let remainingTime = diffDays + 'd ' + diffHrs + 'h ' + diffMins + 'm';
            if (diffMs === undefined) {
                remainingTime = '0d 0h 0m';
            }
            if (data[i].estado === 'enviado' && timeOut || data[i].estado === 'cerrado') {
                estado = 'vencido';
            }
            if (data[i].estado === 'multibanco') {
                this.showMultibancoInfo = true;
                estado = 'multibanco';
            }
            switch (estado) {
                case 'enviado':
                    statusLabel = this.translate.instant('FineGroupPage.Data.StatusType.Pending');
                    break;
                case 'compartido':
                    statusLabel = this.translate.instant('FineGroupPage.Data.StatusType.Shared');
                    break;
                case 'pagado':
                    statusLabel = this.translate.instant('FineGroupPage.Data.StatusType.Paid');
                    break;
                case 'identificado':
                    statusLabel = this.translate.instant('FineGroupPage.Data.StatusType.Identified');
                    break;
                case 'rechazado':
                    statusLabel = this.translate.instant('FineGroupPage.Data.StatusType.Rejected');
                    break;
                case 'vencido':
                    statusLabel = this.translate.instant('FineGroupPage.Data.StatusType.Expired');
                    break;
                case 'multibanco':
                    statusLabel = this.translate.instant('FineGroupPage.Data.StatusType.Multibanco');
                    break;
                default:
                    break;
            }

            this.fines[i] = {
                isChecked: false,
                estado: estado,
                statusLabel: statusLabel,
                acceso: data[i].acceso,
                rolAcceso: data[i].rolAcceso,
                rolPermiso: data[i].rolPermiso,
                cliente: data[i].cliente,
                referencia: data[i].expedienteGesthispania,
                nombreOrganismo: data[i].nombreOrganismo,
                lugar: data[i].lugar,
                tipoInfraccion: data[i].tipoInfraccion,
                matricula: data[i].matricula,
                fechaInfraccion: data[i].fechaDenuncia.slice(0, 10),
                remainingTime: remainingTime,
                importeBrutoSinDescuento: data[i].importeBrutoSinDescuento,
                comisionConDescuento: data[i].comisionConDescuento,
                comisionSinDescuento: data[i].comisionSinDescuento,
                ivaConDescuento: data[i].ivaConDescuento,
                ivaSinDescuento: data[i].ivaSinDescuento,
                importeAPagar: data[i].importeAPagar,
                importePagado: data[i].importePagado,
                timeOut: timeOut,
                idEnlace: data[i].idEnlace,
                fechaProntoPago: data[i].fechaProntoPago,
                fechaFinEnlace: data[i].fechaFinEnlace,
                contrato: data[i].contrato,
                fechaInicioContrato: data[i].fechaInicioContrato,
                fechaFinContrato: data[i].fechaFinContrato,
                expedienteGesthispania: data[i].expedienteGesthispania,
                codigoSancion: data[i].codigoSancion,
                tipoEnlace: data[i].tipoEnlace,
                hasComision: data[i].hasComision,
                timezoneDescriptionPP: DateUtilsService.getTimezoneText(data[i].fechaProntoPago.timezone),
                timezoneDescriptionFFE: DateUtilsService.getTimezoneText(data[i].fechaFinEnlace.timezone),
                pagoActivo: data[i].pagoActivo,
                ficheroMulta: data[i].ficheroMulta,
                ficheroJustificante: data[i].ficheroJustificante,
                justificanteOrganismo: data[i].justificanteOrganismo
            };
        }
        this.rolAcceso = this.fines[0].rolAcceso;
        this.dataLoaded = true;
        this.ngxLoader.stop();
        setTimeout(() => {
            $('#fines').DataTable( {
                pageLength: 12,
                processing: true,
                lengthMenu : [12, 24, 36],
                ordering: true,
                columnDefs: [ {
                    'targets': [0, 9],
                    'orderable': false
                } ],
                language: {
                    'decimal': this.translate.instant('FineGroupPage.DataTable.Decimal'),
                    'emptyTable': this.translate.instant('FineGroupPage.DataTable.EmptyTable'),
                    'info': this.translate.instant('FineGroupPage.DataTable.Info'),
                    'infoEmpty': this.translate.instant('FineGroupPage.DataTable.InfoEmpty'),
                    'infoFiltered': this.translate.instant('FineGroupPage.DataTable.InfoFiltered'),
                    'infoPostFix': this.translate.instant('FineGroupPage.DataTable.InfoPostFix'),
                    'thousands': this.translate.instant('FineGroupPage.DataTable.Thousands'),
                    'lengthMenu': this.translate.instant('FineGroupPage.DataTable.LengthMenu'),
                    'loadingRecords': this.translate.instant('FineGroupPage.DataTable.LoadingRecords'),
                    'processing': this.translate.instant('FineGroupPage.DataTable.Processing'),
                    'search': this.translate.instant('FineGroupPage.DataTable.Search'),
                    'zeroRecords': this.translate.instant('FineGroupPage.DataTable.ZeroRecords'),
                    'paginate': {
                        'first': this.translate.instant('FineGroupPage.DataTable.Paginate.First'),
                        'last': this.translate.instant('FineGroupPage.DataTable.Paginate.Last'),
                        'next': this.translate.instant('FineGroupPage.DataTable.Paginate.Next'),
                        'previous': this.translate.instant('FineGroupPage.DataTable.Paginate.Previous'),
                    }
                }
            } );
            this.fetchSelectedItems();
            this.fetchCheckedIDs();
            window.scrollTo(0, 0);
            this.submitDiv = this._document.getElementById('submit');
        }, 1);
    }

    selectAll(e) {
        if (e.target.checked) {
            this.fines.forEach((value) => {
                if (value.acceso === 1 && value.rolAcceso === 0
                    || value.rolAcceso === 1 || value.rolAcceso === 2 && value.acceso === 4 || value.acceso === 1
                    || value.acceso === 7) {
                    value.isChecked = true;
                }
            });
        } else {
            this.fines.forEach((value) => {
                value.isChecked = false;
            });
        }
        this.fetchCheckedIDs();
    }

    fetchSelectedItems() {
        this.selectedItemsList = this.fines.filter((value) => {
            this.fetchCheckedIDs();
            return value.isChecked;
        });
    }

    fetchCheckedIDs() {
        localStorage.removeItem('expedientes');
        localStorage.removeItem('summary');
        const paymentSummary = [];
        this.checkedIDs = [];
        this.fines.forEach((value) => {
            if (value.isChecked && value.estado !== 'multibanco') {
                this.checkedIDs.push(value.referencia);
                const summaryLine = {
                    expedienteGesthispania: value.referencia,
                    matricula: value.matricula,
                    lugar: value.lugar,
                    tipoInfraccion: value.tipoInfraccion,
                    importeBrutoSinDescuento: value.importeBrutoSinDescuento,
                    comisionConDescuento: value.comisionConDescuento
                };
                paymentSummary.push(summaryLine);
            }
        });
        localStorage.setItem('expedientes', JSON.stringify(this.checkedIDs));
        localStorage.setItem('summary', JSON.stringify(paymentSummary));
        this.noFinesSelected = this.checkedIDs.length <= 0;
        this.groupSelected();
    }

    action(type, file?) {
        if (file && file !== 'undefined') {
            localStorage.removeItem('expedientes');
            localStorage.removeItem('summary');
            this.checkedIDs = [];
            this.checkedIDs.push(file);
            const paymentSummary = [];
            this.fines.forEach((value) => {
                if (value.referencia === file && value.estado !== 'multibanco') {
                    const summaryLine = {
                        expedienteGesthispania: value.referencia,
                        matricula: value.matricula,
                        lugar: value.lugar,
                        tipoInfraccion: value.tipoInfraccion,
                        importeBrutoSinDescuento: value.importeBrutoSinDescuento,
                        comisionConDescuento: value.comisionConDescuento
                    };
                    paymentSummary.push(summaryLine);
                }
            });
            localStorage.setItem('summary', JSON.stringify(paymentSummary));
            localStorage.setItem('expedientes', JSON.stringify(this.checkedIDs));
        }
        switch (type) {
            case 'view':
                const expedientes = JSON.parse(localStorage.getItem('expedientes'));
                this.actualFine = this.fines.find((fine) => fine.referencia === expedientes[0]);
                this.viewFineModal = true;
                if (this.actualFine.tipoEnlace === '2COM') {
                    if (this.actualFine.fechaProntoPago != null && this.actualFine.fechaHoraServidor != null) {
                        const dateProntoPago = this.actualFine.fechaProntoPago.date;
                        const datenow = this.actualFine.fechaHoraServidor.date;
                        const dateProntoPagof = new Date(dateProntoPago.replace(' ', 'T'));
                        const datenowf = new Date(datenow.replace(' ', 'T'));

                        if (datenowf.getTime() > dateProntoPagof.getTime()) {
                            this.isprontopagofine = false;
                        }

                    } else {
                        this.isprontopagofine = false;
                    }
                }
                if ((this.actualFine.importeAPagar < this.actualFine.importeDenuncia) || (this.actualFine.importePagado < this.actualFine.importeDenuncia)) {
                    this.hasDiscount = true;
                }
                this.pdfdataService.setURLPdf(this.actualFine.ficheroMulta, 'fine');
                this.filePdfUrl = this.pdfdataService.getURLPdf('fine');
                if (this.actualFine.estado === 'pagado') {
                    const stateMsg: any = this.translate.instant('FinePage.State2');
                    this.pdfdataService.setURLPdf(this.actualFine.ficheroJustificante, 'paidfine');
                    this.pdfdataService.setURLPdf(this.actualFine.justificanteOrganismo, 'jdp');
                    this.filePdfUrlPagado = this.pdfdataService.getURLPdf('paidfine');
                    this.justificantePagoOrganismo = this.pdfdataService.getURLPdf('jdp');
                }
                break;
            case 'identify':
                this.router.navigate([`app/identify/${this.hash}`]);
                break;
            case 'pay':
                this.router.navigate([`app/payment/${this.hash}`]);
                break;
            case 'share':
                this.router.navigate([`app/share/${this.hash}`]);
                break;
            case 'reject':
                this.router.navigate([`app/reject/${this.hash}`]);
                break;
            case 'cancel':
                this.multibancoValues = [];
                this.regularValues = [];
                for (let i = 0; i < this.fines.length; i++) {
                    if (this.fines[i].referencia === file) {
                        if (this.fines[i].estado === 'multibanco') {
                            this.multibancoValues.push(this.fines[i].idEnlace);
                            this.showCancelButton = true;
                        } else {
                            this.regularValues.push(this.fines[i].referencia);
                        }
                    }
                }
                this.checkMultibancoCancelledSources();
                break;
        }
    }

    showIdentify(fine): boolean {
        let show = false;
        if (fine.timeOut) {
            show = false;
        } else {
            if ((this.rolAcceso === 1 || this.rolAcceso === 2) && (fine.acceso === 4 || fine.acceso === 1)) {
                show = true;
            } else if (this.rolAcceso === 0 && fine.acceso === 1) {
                show = true;
            }
        }
        return show;
    }

    showPay(fine): boolean {
        let show = false;
        if (fine.timeOut || fine.importeBrutoSinDescuento <= 0) {
            show = false;
        } else {
            if ((this.rolAcceso === 1 || this.rolAcceso === 2) && (fine.acceso === 4 || fine.acceso === 1)) {
                show = true;
            } else if (this.rolAcceso === 0 && fine.acceso === 1) {
                show = true;
            }
        }
        return show;
    }

    showShare(fine): boolean {
        let show = false;
        if (fine.timeOut) {
            show = false;
        } else {
            if (this.rolAcceso === 0 && fine.acceso === 1) {
                show = true;
            }
        }
        return show;
    }

    showReject(fine): boolean {
        let show = false;
        if (fine.timeOut) {
            show = false;
        } else {
            if ((this.rolAcceso === 1 || this.rolAcceso === 2) && fine.acceso === 4) {
                show = true;
            }
        }
        return show;
    }

    showCancel(fine): boolean {
        let show = false;
        if (fine.timeOut) {
            show = false;
        } else {
            if (fine.estado === 'multibanco' && fine.acceso === 7) {
                show = true;
            }
        }
        return show;
    }

    groupPaymentAvailable(): boolean {
        const expedientes = JSON.parse(localStorage.getItem('expedientes'));
        let groupPaymentAvailable = false;
        for (let i = 0; i < this.fines.length; i++) {
            if (expedientes.includes(this.fines[i].referencia) && this.multibancoValues.length === 0 && this.pagoActivo) {
                if (this.fines[i].importeBrutoSinDescuento !== 0) {
                    groupPaymentAvailable = true;
                } else {
                    groupPaymentAvailable = false;
                }
            }
        }
        return groupPaymentAvailable;
    }

    scrollToSubmit() {
        if (!this.noFinesSelected) {
            const yOffset = -300;
            const y = this.submitDiv.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
        }
    }

    showSelectAll() {
        for (let i = 0; i < this.fines.length; i++) {
            if (this.showPay(this.fines[i]) || this.showIdentify(this.fines[i]) || this.showShare(this.fines[i]) || this.showReject(this.fines[i])
                || this.showCancel(this.fines[i])) {
                return true;
            }
        }
        return false;
    }

    exit() {
        this.window.location.reload();
    }

    groupSelected() {
        this.multibancoValues = [];
        this.regularValues = [];
        for (let i = 0; i < this.fines.length; i++) {
            if (this.fines[i].isChecked) {
                if (this.fines[i].estado === 'multibanco') {
                    this.multibancoValues.push(this.fines[i].idEnlace);
                    this.showCancelButton = true;
                    this.noFinesSelected = false;
                } else {
                    this.regularValues.push(this.fines[i].referencia);
                    this.noFinesSelected = false;
                }
            }
        }
    }
}
